(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var body = document.body;
  var theme = body.getAttribute('data-particle-theme') || 'white';

  var PALETTES = {
    white: ['#ff5a3c', '#ff2b2b', '#ff8a3d', '#e0273d'], // catalogo: rojo/brasa
    gold: ['#ffe9b0', '#f4d585', '#e3b654', '#cf9d3f']   // producto: dorado
  };
  var colors = PALETTES[theme] || PALETTES.white;

  // ---- config ----
  var HERO_RATIO = 0.14;
  var CROSS_TIME_SEC_MIN = 9;
  var CROSS_TIME_SEC_MAX = 16;
  var MOUSE_RADIUS = 55;
  var MOUSE_FORCE = 0.22;
  var TARGET_FPS = 30;
  var MAX_DPR = 1.5;
  var VIGNETTE = true;
  var DENSITY_DIVISOR = 11000;
  var MIN_PARTICLES = 40;
  var MAX_PARTICLES_CAP = 130;

  // tamaños en px reales (nucleo). el sprite agrega el halo alrededor.
  var DUST_CORE_MIN = 0.5, DUST_CORE_MAX = 1.3;
  var HERO_CORE_MIN = 1.6, HERO_CORE_MAX = 2.8;
  // -----------------

  var wrap = document.createElement('div');
  wrap.id = 'particle-dust-wrap';
  wrap.setAttribute('aria-hidden', 'true');
  wrap.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:0;top:0;left:0;overflow:hidden;';

  var canvas = document.createElement('canvas');
  canvas.id = 'particle-dust-canvas';
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;';
  wrap.appendChild(canvas);

  if (VIGNETTE) {
    var vg = document.createElement('div');
    vg.style.cssText = 'position:absolute;inset:0;pointer-events:none;background:radial-gradient(ellipse at center, rgba(0,0,0,0) 45%, rgba(0,0,0,0.22) 100%);';
    wrap.appendChild(vg);
  }

  document.body.insertBefore(wrap, document.body.firstChild);
  var ctx = canvas.getContext('2d', { alpha: true });

  // ---------- un solo tipo de sprite: punto con glow suave ----------
  var SPRITE_RES = 64;
  function makeGlowSprite(hex) {
    var off = document.createElement('canvas');
    off.width = SPRITE_RES; off.height = SPRITE_RES;
    var octx = off.getContext('2d');
    var c = SPRITE_RES / 2;

    var core = octx.createRadialGradient(c, c, 0, c, c, c * 0.35);
    core.addColorStop(0, '#fff8ee');
    core.addColorStop(0.4, hex + 'ff');
    core.addColorStop(1, hex + '00');
    octx.fillStyle = core;
    octx.beginPath();
    octx.arc(c, c, c * 0.35, 0, Math.PI * 2);
    octx.fill();

    var halo = octx.createRadialGradient(c, c, c * 0.2, c, c, c);
    halo.addColorStop(0, hex + '40');
    halo.addColorStop(1, hex + '00');
    octx.fillStyle = halo;
    octx.beginPath();
    octx.arc(c, c, c, 0, Math.PI * 2);
    octx.fill();

    return off;
  }

  var sprites = colors.map(function (c) { return makeGlowSprite(c); });

  var W, H, dpr, MAX_PARTICLES, riseMin, riseMax;
  function recalc() {
    dpr = Math.min(window.devicePixelRatio || 1, MAX_DPR);
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var area = W * H;
    MAX_PARTICLES = Math.max(MIN_PARTICLES, Math.min(MAX_PARTICLES_CAP, Math.round(area / DENSITY_DIVISOR)));
    riseMax = H / (CROSS_TIME_SEC_MIN * TARGET_FPS);
    riseMin = H / (CROSS_TIME_SEC_MAX * TARGET_FPS);
  }
  recalc();

  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(recalc, 150);
  });

  function spawn() {
    var depth = Math.random();
    var isHero = Math.random() < HERO_RATIO;
    var core = isHero
      ? (HERO_CORE_MIN + depth * (HERO_CORE_MAX - HERO_CORE_MIN))
      : (DUST_CORE_MIN + depth * (DUST_CORE_MAX - DUST_CORE_MIN));
    return {
      x: Math.random() * W,
      y: H + 10 + Math.random() * 30,
      core: core,
      vy: -(riseMin + depth * (riseMax - riseMin)) * (isHero ? 0.85 : 1),
      vx: (Math.random() - 0.5) * 0.05,
      wobblePhase: Math.random() * Math.PI * 2,
      wobbleSpeed: 0.012 + Math.random() * 0.014,
      depth: depth,
      hero: isHero,
      colorIdx: Math.floor(Math.random() * colors.length),
      alphaMax: isHero ? (0.75 + depth * 0.25) : (0.14 + depth * 0.24),
      flicker: 1,
      flickerTarget: 1,
      flickerSpeed: 0.06 + Math.random() * 0.08
    };
  }

  var particles = [];
  for (var i = 0; i < MAX_PARTICLES; i++) {
    var p = spawn();
    p.y = Math.random() * H;
    particles.push(p);
  }

  var pointer = { x: -999, y: -999, active: false };
  function setPointer(cx, cy) { pointer.x = cx; pointer.y = cy + window.scrollY; pointer.active = true; }
  window.addEventListener('mousemove', function (e) { setPointer(e.clientX, e.clientY); }, { passive: true });
  window.addEventListener('mouseleave', function () { pointer.active = false; });
  window.addEventListener('touchmove', function (e) {
    if (e.touches[0]) setPointer(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true });
  window.addEventListener('touchend', function () { pointer.active = false; });

  var visible = !document.hidden;
  document.addEventListener('visibilitychange', function () {
    visible = !document.hidden;
    if (visible) requestAnimationFrame(loop);
  });

  var lastFrame = 0;
  var frameInterval = 1000 / TARGET_FPS;

  function loop(now) {
    if (!visible) return;
    requestAnimationFrame(loop);
    if (now - lastFrame < frameInterval) return;
    lastFrame = now;

    var scrollY = window.scrollY;
    ctx.clearRect(0, 0, W, H);

    while (particles.length < MAX_PARTICLES) particles.push(spawn());
    if (particles.length > MAX_PARTICLES) particles.length = MAX_PARTICLES;

    for (var i = particles.length - 1; i >= 0; i--) {
      var p = particles[i];

      if (pointer.active) {
        var dx = p.x - pointer.x;
        var dy = p.y - (pointer.y - scrollY);
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        if (dist < MOUSE_RADIUS) {
          var force = (MOUSE_RADIUS - dist) / MOUSE_RADIUS * MOUSE_FORCE;
          p.vx += (dx / dist) * force;
          p.vy += (dy / dist) * force;
        }
      }

      p.vx *= 0.95;
      var naturalVy = -(riseMin + p.depth * (riseMax - riseMin)) * (p.hero ? 0.85 : 1);
      p.vy += (naturalVy - p.vy) * 0.05;

      p.wobblePhase += p.wobbleSpeed;
      var wobble = Math.sin(p.wobblePhase) * 0.25;

      p.x += p.vx + wobble;
      p.y += p.vy;

      if (Math.random() < 0.012) p.flickerTarget = 0.45 + Math.random() * 0.55;
      p.flicker += (p.flickerTarget - p.flicker) * p.flickerSpeed;

      if (p.x < -20) p.x = W + 20;
      if (p.x > W + 20) p.x = -20;

      if (p.y < -20) {
        particles.splice(i, 1);
        continue;
      }

      var fade = 1;
      if (p.y > H - 30) fade = Math.max((H - p.y) / 30, 0);
      else if (p.y < 30) fade = Math.max(p.y / 30, 0);

      var alpha = Math.min(p.alphaMax * p.flicker * fade, 1);

      var scale = p.core / (SPRITE_RES * 0.35 / 2);
      var size = SPRITE_RES * scale;

      ctx.globalAlpha = alpha;
      ctx.drawImage(sprites[p.colorIdx], p.x - size / 2, p.y - size / 2, size, size);
    }
    ctx.globalAlpha = 1;
  }

  requestAnimationFrame(loop);
})();